import { Range } from "../models/ThemeModels";
import { HTTPClient } from "@abaco/web-common/src/HTTP";

export default class ThemeApi {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getLayerEntries(pk_cuaa: number, theme_id: number): Promise<Range[]>
    {
        const res = await this.http.get(`/map/api/v1/farms/${pk_cuaa}/themes/${theme_id}/entries`)

        return res.data
    }

    public async addThemeEntries(pk_cuaa: number, theme_id: number, entries: Range[]){
        const res = await this.http.post(`/map/api/v1/farms/${pk_cuaa}/themes/${theme_id}/entries`, {
            entries
        })
        return res.data;
    }

    public async resetThemes(pk_cuaa: number, theme_id: number){
        return await this.http.delete(`/map/api/v1/farms/${pk_cuaa}/themes/${theme_id}`);
    }
}
